import Component from '../core/Component'
import anime from 'animejs'

export default class JobList extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            inner: null,
            tabs: [],
            items: []
        }
    }

    prepare() {
        this.ref.tabs.forEach(tab => {
            tab.addEventListener('click', this.handleTabClick)
        })
    }

    handleTabClick = async event => {
        event.preventDefault()
        const type = event.currentTarget.dataset.type

        this.ref.tabs.forEach(tab => tab.classList.remove('is-active'))
        event.currentTarget.classList.add('is-active')

        let items = []
        this.heightStart = this.ref.inner.offsetHeight
        this.ref.inner.style.position = `absolute`
        this.ref.inner.style.left = `0`
        this.ref.inner.style. width = `100%`
        this.element.style.height = `${this.heightStart}px`
        items = this.ref.items.filter(item => item.classList.contains('is-active'))
        await this.hideItems(items)
        items = this.ref.items.filter(item => item.dataset.type === type || type === 'all')
        await this.showItems(items)
    }

    showItems(items) {
        return new Promise((resolve) => {
            const tl = anime.timeline({
                easing: 'easeOutSine',
                duration: 250,
            })

            items.forEach(item => {
                anime.set(
                    item, {
                    opacity: 0,
                }
                )
                item.classList.add('is-active')
            })

            requestAnimationFrame(() => {
                tl
                .add({
                    targets: this.element,
                    height: [this.heightStart, this.ref.inner.offsetHeight],
                    duration: 500,
                    complete: () => {
                        this.ref.inner.style.position =''
                        this.ref.inner.style.left =''
                        this.ref.inner.style.width =''
                        this.element.style.height = ''
                    }
                })
                .add({
                    targets: items,
                    opacity: [0, 1],
                    delay: anime.stagger(50),
                    complete: () => {
                        items.forEach(item => {
                            item.classList.add('is-active')
                        })
                        resolve()
                    }
                },"-=400")
            })
        })
    }

    hideItems(items) {
        return new Promise((resolve) => {
            const tl = anime.timeline({
                easing: 'easeOutSine',
                duration: 250,
            })

            tl
            .add({
                targets: items,
                opacity: [1, 0],
                delay: anime.stagger(50),
                complete: () => {
                    items.forEach(item => {
                        item.classList.remove('is-active')
                    })
                    resolve()
                }
            })
        })
    }
}